import { Plugin } from './plugin';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';

export class PluginSlot {

    public name: string;

    /**
     * The list of registered plugins.
     *
     * @type {{}}
     */
    protected plugins = [];

    /**
     * The observer that watches for changes in the registered slots.
     *
     * @type {Subject<any>}
     */
    public observer: ReplaySubject<any> = new ReplaySubject();

    constructor(name: string) {
        this.name = name;
    }

    /**
     * An observable which is triggered when a modal is added or removed.
     *
     * @returns {Observable<any>}
     */
    public listen() {
        return this.observer;
    }

    /**
     * Add a new plugin.
     *
     * @returns {Plugin}
     * @param plugin
     */
    public add(plugin) {
        if (this.get(plugin.name)) {
            this.remove(plugin.name);
        }

        this.plugins.push(plugin);

        this.observer.next({
            add: plugin
        });

        return plugin;
    }

    /**
     * Get the plugin with the given name.
     *
     * @param name
     * @returns {null}
     */
    public get(name: string) {
        return this.plugins.find(plugin => plugin.name === name);
    }

    /**
     * Remove the plugin with the given name.
     *
     * @param name
     */
    public remove(name: string) {
        const index = this.plugins.findIndex((plugin) => {
            return plugin.name === name;
        });

        if (index >= 0) {
            this.observer.next({
                remove: this.plugins[index]
            });

            this.plugins.splice(index, 1);
        }
    }

    /**
     * Get all the plugins.
     *
     * @returns {{}}
     */
    public all() {
        return this.plugins;
    }

    /**
     * Clear the list of plugins.
     */
    public clear() {
        this.plugins.forEach((plugin: Plugin) => {
            this.remove(plugin.name);
        });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/classes/plugin-slot.ts